import { render } from "./ModeloCadastro.vue?vue&type=template&id=3b5f63ea&scoped=true"
import script from "./ModeloCadastro.vue?vue&type=script&lang=ts"
export * from "./ModeloCadastro.vue?vue&type=script&lang=ts"

import "./ModeloCadastro.vue?vue&type=style&index=0&id=3b5f63ea&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3b5f63ea"

export default script